import { useState } from "react";
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { getTranslateByKey } from "@/main/services/utils";
import { ProcurementReportScheduleGridResponse } from "@/main/models/response";
import { ProcurementReportScheduleSearchGridRequest } from "@/main/models/request";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import GridScheduleReport from "./gridReportSchedule/gridScheduleReport";
import FiltersOrderReportScheduleWrapper from "./filtersOrderReportSchedule/filtersOrderReportSchedule";
import { IEditDataSchedule } from "./types";

function OrderReportScheduleScreen() {
	const [dataGrid, setDataGrid] = useState<ProcurementReportScheduleGridResponse[]>([]);
	const [formFilters, setFormFilters] = useState<ProcurementReportScheduleSearchGridRequest | null>(null);
	const [dataEdit, setDataEdit] = useState<IEditDataSchedule>(null);

	function onResetSearch() {
		setDataGrid([]);
		setFormFilters(null);
	}

	async function getData(
		filters: ProcurementReportScheduleSearchGridRequest | Partial<ProcurementReportScheduleSearchGridRequest> = {},
		isResetSearch: boolean = true,
	) {
		const request: ProcurementReportScheduleSearchGridRequest = {
			...(isResetSearch ? {} : formFilters),
			...(filters as ProcurementReportScheduleSearchGridRequest),
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize30,
		};

		onResetSearch();
		setFormFilters(request);
	}

	function updateDataEdit(data: IEditDataSchedule) {
		setDataEdit(data);
	}

	const titleScreen = `${getTranslateByKey("module.report")} > ${getTranslateByKey("screen.orderReportSchedule")}`;

	return (
		<ContainerScreen hasBackground title={titleScreen}>
			<FiltersOrderReportScheduleWrapper
				onResetSearch={onResetSearch}
				getData={getData}
				dataEdit={dataEdit}
				updateDataEdit={updateDataEdit}
			/>
			<GridScheduleReport
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				getData={getData}
				updateDataEdit={updateDataEdit}
			/>
		</ContainerScreen>
	);
}

export default OrderReportScheduleScreen;
